import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import PublicIcon from '@mui/icons-material/Public';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';

interface FolderState {
    published?: boolean;
    sharedWithCompany?: boolean;
    /** Received from another user in the company. */
    shared?: boolean;
}

/** Published and company-share marks for a folder card or table row. */
export const FolderStateIcons: React.FC<{ folder: FolderState; size?: number }> = ({ folder, size = 16 }) => {
    const theme = useTheme();
    const published = Boolean(folder.published);
    const shared = Boolean(folder.sharedWithCompany || folder.shared);
    if (!published && !shared) return null;

    const plate = {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size + 10,
        height: size + 10,
        borderRadius: '50%',
        bgcolor: alpha(theme.palette.background.paper, 0.92),
        border: `1px solid ${alpha(theme.palette.divider, 0.9)}`,
        boxShadow: `0 1px 3px ${alpha('#000', 0.25)}`,
    };

    return (
        <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }} aria-hidden={false}>
            {published && (
                <Tooltip title="Published">
                    <Box sx={plate}>
                        <PublicIcon sx={{ fontSize: size, color: 'success.main' }} aria-label="Published" />
                    </Box>
                </Tooltip>
            )}
            {shared && (
                <Tooltip title="Shared with company">
                    <Box sx={plate}>
                        <ShareOutlinedIcon sx={{ fontSize: size, color: 'info.main' }} aria-label="Shared with company" />
                    </Box>
                </Tooltip>
            )}
        </Box>
    );
};
